import React from 'react'

const SvgMinusCircleFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 5.522-4.477 10-10 10S2 17.522 2 12zm14-1H8v2h8v-2z' />
  </svg>
)

export default SvgMinusCircleFilled
